export default "__VITE_ASSET__Du5EaFyO__"